import {
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function saveDataInExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_BEGIN,
    });
    const { projectId, version, dataForSave } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano`,
        dataForSave,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissSaveDataInExternalDbError() {
  return {
    type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_BEGIN:

      return {
        ...state,
        saveDataInExternalDbPending: true,
        saveDataInExternalDbError: null,
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_SUCCESS:

      return {
        ...state,
        saveDataInExternalDbPending: false,
        saveDataInExternalDbError: null,
        xanoSavedData: action.data
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_FAILURE:

      return {
        ...state,
        saveDataInExternalDbPending: false,
        saveDataInExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR:

      return {
        ...state,
        saveDataInExternalDbError: null,
      };

    default:
      return state;
  }
}
